import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GettingAllAgents } from "../../allApi/api";



export const allAgentsFetch=createAsyncThunk("data/allAgentsFetch",async()=>{
try {
  const getData = await GettingAllAgents();
  const data = getData?.agents;
  localStorage.setItem("session_id", data?.[0]?.session_id);
  return data
} catch (error) {
  throw new Error("Something went wrong")
}
})

export const initialData = {
  availableAgent: [],
  waveflowModal: {},
  waveFlowModalList: [],
  waveFlowDelete: "",
  waveflowTool: {},
  waveFlowToolsDelete: "",
  waveFlowChatUserOption: "",
  activeToolsList: [],
  preDefinedFilter: null,
  agentaddTrigger:[],
  loading:false,
  allAgentData:[],
  clearefetchagentsData:false,
  error:null,
  resetLoading:false,
  workflowAdminList:[],
  isFetchWorkflow:null,
  userCount: 0, 
  waveflowagentsData:{}

};

const waveflowSearchData = createSlice({
  name: "waveflow",
  initialState: initialData,
  reducers: {
    waveFlowdataAdd(state, action) {
      state.availableAgent = action.payload;
    },
    waveflowDataTrigger(state,action){
      state.agentaddTrigger = action.payload;
    },
    waveFlowdataUpdate(state, action) {
      state.availableAgent = action.payload;
    },
    waveFlowModaladd(state, action) {
      state.waveflowModal = action.payload;
    },
    waveflowModelList(state, action) {
      state.waveFlowModalList = action.payload;
    },
    waveflowModelDelete(state, action) {
      state.waveFlowDelete = action.payload;
    },
    waveflowToolsAdd(state, action) {
      state.waveflowTool = action.payload;
    },
    waveflowToolsDelete(state, action) {
      state.waveFlowToolsDelete = action.payload;
    },
    waveflowchatOption(state, action) {
      state.waveFlowChatUserOption = action.payload;
    },
    waveFlowactiveToolsList(state, action) {
      state.activeToolsList = action.payload;
    },
    waveflowpreDefinedFilter(state, action) {
      state.preDefinedFilter = action.payload;
    },
    waveflowclearefetchagentsData(state,action){
      state.clearefetchagentsData=false
    },
    waveflowResetLoading(state,action){
      state.resetLoading=action?.payload
    },
    waveflowWorkflowAdminscreenData(state,action){
      state.workflowAdminList=action?.payload
      state.isFetchWorkflow=true
    },
    userCountData(state, action) {
      state.userCount = action.payload;
    },
    setwaveflowagentsData(state,{payload}){
      state.waveflowagentsData=payload
    },
     setAgentdataclearData(state){
      state.allAgentData=[]
    }

  },
  extraReducers:(builder)=>{
    builder.addCase(allAgentsFetch.pending,(state)=>{
      state.loading=true
    })
    .addCase(allAgentsFetch.fulfilled,(state,action)=>{
      state.loading=false
      state.allAgentData=action.payload
      state.clearefetchagentsData=true
    })
    .addCase(allAgentsFetch.rejected,(state,action)=>{
      state.loading=false
      state.error=action.error.message
    })
  }
});

export const {
  
  userCountData,
  waveflowchatOption,
  waveflowToolsDelete,
  waveflowToolsAdd,
  waveflowModelDelete,
  waveFlowdataAdd,
  waveFlowdataUpdate,
  waveflowDataTrigger,
  waveFlowModaladd,
  waveflowModelList,
  waveflowpreDefinedFilter,
  waveFlowactiveToolsList,
  waveflowResetLoading,
  waveflowclearefetchagentsData,
  waveflowWorkflowAdminscreenData,
  setwaveflowagentsData,
  setAgentdataclearData
} = waveflowSearchData.actions;
export default waveflowSearchData.reducer;
